/*
 * Created on Sat Jul 3 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 */

import { useState, useEffect } from "react";
import { useParams, Redirect, useHistory } from "react-router-dom";
import { StickyHeader } from "./terms";
import { ErrorMsg, ErrorPopup, PasswordInput, FormButtons, addEmptyFields, clearEmptyFields } from "../components";
import { useWindowDimensions } from "../utils/helpers";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import preloader from "../assets/images/preloaders/04-preloader-4px-f5f5f5.gif";
import { SuccessModal } from './find';

import useCompletePasswordReset from '../hooks/complete-password-reset.hook'
import useAuth from "hooks/auth.hook";
import { CloseButton } from '../components'

// const schema = yup.object().shape({
//     password: yup
//         .string()
//         .required()
//         .min(7, 'Oops! We hate this too. But password needs a minimum of 7 characters, with at least 1 alphabet and 1 numerical digit.')
//         .matches(/([\s\S])([1-9])/, 'Oops! We hate this too. But password needs a minimum of 7 characters, with at least 1 alphabet and 1 numerical digit.'),
//     confirmPassword: yup
//         // .min(7, 'Oops! We hate this too. But password needs a minimum of 7 characters, with at least 1 alphabet and 1 numerical digit.')
//         // .matches(/([\s\S])([1-9])/, 'Oops! We hate this too. But password needs a minimum of 7 characters, with at least 1 alphabet and 1 numerical digit.')
//         .string().required().when("password", {
//             is: false,
//             then: fieldSchema => fieldSchema.oneOf([yup.ref('password')], "Oops! Your passwords don't match!")
//           })

// });

const schema = yup.object().shape({
    password: yup
        .string()
        .required()
        .min(7, 'Oops! We hate this too. But password needs a minimum of 7 characters, with at least 1 alphabet and 1 numerical digit.')
        .matches(/([\s\S])([1-9])/, 'Oops! We hate this too. But password needs a minimum of 7 characters, with at least 1 alphabet and 1 numerical digit.'),
    confirmPassword: yup
        .string()
        .required()
        .when("password", {
            is: (value) => value ? value.length >= 7 && value.match(/([\s\S])([1-9])/) : false,
            then: fieldSchema => fieldSchema.oneOf([yup.ref('password')], "Oops! Your passwords don't match!"),
        })

});


export default function ResetPassword() {
    const { session } = useAuth()
    const { complete, isSuccess, isLoading, isError } = useCompletePasswordReset();

    const methods = useForm({
        shouldFocusError: false,
        resolver: yupResolver(schema),
    });
    const { watch, reset, handleSubmit, setError, formState: { errors, isSubmitted, isSubmitting } } = methods;

    document.body.style.background = '#d7d7d7';
    const { code } = useParams();

    const [formHasValue, setFormHasValue] = useState(false);
    const [passwordIsReset, setPasswordIsReset] = useState(false);
    const [layoutHeight, setLayoutHeight] = useState(0);
    const [formData, setFormData] = useState([]);

    const { isMobile } = useWindowDimensions();
    const { push } = useHistory()
    // let resetToken = JSON.parse(localStorage.getItem("resetToken"));

    watch(data => {
        if (!Object.values(data).some(val => val)) {
            setFormHasValue(false);
        }
        else setFormHasValue(true);
    })

    const onReset = () => {
        reset({});
        clearEmptyFields();
        setFormHasValue(false);
    }
    const onSubmit = (data, e) => {
        // setFormData(data);
        complete({
            code,
            password: data.password
        })
        // setPasswordIsReset(true);
    }

    useEffect(() => {
        setLayoutHeight(window.innerHeight);
    }, []);
    useEffect(() => {
        if (isSubmitted || isSubmitting) addEmptyFields(errors);
        // eslint-disable-next-line
    }, [isSubmitted, isSubmitting]);

    // useEffect(() => {
    //     errors && !errors.password ? setPasswordIsValid(true) : setPasswordIsValid(false);
    // }, [errors])

    // if (id !== resetToken) return <Redirect to="/login" />

    useEffect(() => {
        if (isError) {
            setError('password', {
                message: 'Oops! code is invalid'
            })
        }
    }, [isError])

    useEffect(() => {
        if (isSuccess) {
            setPasswordIsReset(true);
        }
    }, [isSuccess])
    
    return (
        <>
            <StickyHeader text="reset password" takeOver={true} top={session ? `${(isMobile ? 45:65)}px`:'unset'} />
            {passwordIsReset ? <SuccessModal modalClass="reset-password" greyText="Your password has been successfully <br/>changed!" redirect="/login" /> : null}
            <div id="resetMain" style={isMobile ?
                {
                    position: 'relative',
                    height: layoutHeight
                }
                : null}>
                {false ? <CloseButton 
                    closeModal={() => {
                        push('/')
                    }} 
                    passOpacity={() => {
                        
                    }} darkGrey={true} /> : null}
                <div className="middle-xy text-left">
                    <FormProvider {...methods}>
                        <form
                            id="modalForm"
                            className="signup-form border-0"
                            autoComplete="off"
                            noValidate="novalidate"
                        >
                            <ErrorPopup condition={errors.password?.type === 'required' || errors.confirmPassword?.type === 'required'} message={'Oops! The highlighted fields are required!'} />
                            <PasswordInput label="New password" className="modal-popup" name="password" leaveErrors={true} showAllPinkBackground={true} />
                            <ErrorMsg name="password" className="mb-3" hide={errors.password?.type === 'required'} />
                            <PasswordInput label="Confirm password" className="modal-popup" name="confirmPassword" leaveErrors={true} showAllPinkBackground={true} />
                            <ErrorMsg name="confirmPassword" className="mb-2" hide={errors.confirmPassword?.type === 'required'} />
                        </form>
                    </FormProvider>
                </div>
                <FormButtons 
                    disabled={!formHasValue} 
                    reset={onReset} 
                    submit={handleSubmit(onSubmit)} 
                    formData={formData} 
                    preloader={preloader} 
                />\
            </div>
        </>
    );
}